import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getFormData, getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { IJob } from 'jobsOld/types';
import { IJobAttachmentRequestPayload } from 'jobsOld/types';

export const getMany = async (requestPayload: IRequestPayload): Promise<GetManyResponse<IJob>> => {
  const { data } = await partfinitiClient.get(
    `/bom/list/boms?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`
  );

  return mapRecordsFromServer<IJob>(data.data, data.recordsFiltered);
};

export const getAttachments = async (
  requestPayload: IJobAttachmentRequestPayload,
  signal: AbortSignal
): Promise<GetManyResponse<any>> => {
  const { data } = await partfinitiClient.get(
    `/bom/list/attached-files?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<any>(data.data);
};

export const upsertJobsWithAttachments = async (data) => {
  const dataToSend = getFormData(data);

  const result = await partfinitiClient.post('/bom/edit/save-with-attachments', dataToSend, {
    'Content-Type': 'multipart/form-data',
  });

  return objectKeysCamelToSnakeCase(result.data);
};
